import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--border)] mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-6">
          <p className="font-serif text-4xl">Sem.IA</p>
          <p className="text-[var(--text-secondary)] mt-3 max-w-sm">Votre compagne IA qui écoute, parle, écrit et crée des images avec vous.</p>
        </div>
        <div className="md:col-span-3 flex flex-col gap-2">
          <span className="label-mono text-[var(--text-muted)]">Explorer</span>
          <Link data-testid="footer-link-studio" to="/studio" className="nav-link">Studio</Link>
          <Link data-testid="footer-link-apropos" to="/a-propos" className="nav-link">À propos</Link>
          <Link data-testid="footer-link-contact" to="/contact" className="nav-link">Contact</Link>
        </div>
        <div className="md:col-span-3 text-sm text-[var(--text-muted)] self-end">© {new Date().getFullYear()} Sem.IA — Fait avec soin à Paris</div>
      </div>
    </footer>
  );
}
